<template>
   <div id="app-root">
      <router-view />
      <DowntimeBanner v-if="showDowntimeBanner" />
      <PhoneVerificationManager />
   </div>
</template>

<script>
import { defineComponent } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import DowntimeBanner from 'components/DowntimeBanner.vue';
import PhoneVerificationManager from 'components/PhoneVerificationManager.vue';

const CHAT_DOWNTIME_BANNER_ROUTES = new Set(['chat', 'existing-chat']);
const LOGIN_DOWNTIME_BANNER_ROUTES = new Set(['home', 'login', 'loginab', 'fake-login', 'login-extension']);
const SHOW_DOWNTIME_BANNER_ON_LOGIN = process.env.SHOW_DOWNTIME_BANNER_ON_LOGIN === 'true';

export default defineComponent({
   name: 'App',
   components: {
      DowntimeBanner,
      PhoneVerificationManager
   },
   computed: {
      showDowntimeBanner() {
         return (
            CHAT_DOWNTIME_BANNER_ROUTES.has(this.$route.name) ||
            (SHOW_DOWNTIME_BANNER_ON_LOGIN && LOGIN_DOWNTIME_BANNER_ROUTES.has(this.$route.name))
         );
      }
   },
   mounted() {
      window.$bus = this.$bus;
      if (typeof window !== 'undefined') {
         console.info(
            '%cSecurity researchers',
            'font-weight:700;color:#00a878;',
            'Found a vulnerability in GapGPT? Please report it through our bug bounty program: https://gapgpt.app/bugbounty'
         );
      }
   },
   beforeCreate() {
      // Generate UUID if not exists in cookie using Quasar's cookie utilities
      if (!this.$q.cookies.has('did')) {
         const newUUID = uuidv4();
         this.$q.cookies.set('did', newUUID, {
            expires: 365, // days
            path: '/',
            sameSite: 'Lax'
         });
      }
   }
});
</script>
